<mat-form-field 
  oneSearchField
  oneSearchFieldBorder="rounded"
  oneSearchFieldAppearance="outline"
  oneSearchFieldSize="slim"
  class="auditTrail-list-search"
>
<mat-icon matPrefix>
      search
    </mat-icon>
    <input matInput placeholder="Search" [formControl]="auditTrailSearch" (keyup)="applyFilter($event.target.value)"/>
    <button *ngIf="auditTrailSearch.value" one-icon-button-flat mat-flat-button matSuffix (click)="auditTrailSearch.setValue(''); applyFilter('')">
      <mat-icon>clear</mat-icon>
    </button>
  </mat-form-field>